/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DataGridModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import { toFixed } from 'ng/shared/utils/math.utils';

/**
 * @description
 *     Pipe to round a value to a desired number of digits after decimal point.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'toFixed',
})
export class ToFixedPipe implements PipeTransform {
    // eslint-disable-next-line class-methods-use-this
    public transform(value: number | string, digits = 0): number {
        return toFixed(Number(value), digits);
    }
}
